<template>
  <validation-provider
    #default="{ errors }"
    name="documentType"
    :rules="{
      required: requiredField,
    }"
  >
    <b-form-group
      label="Tipo do Documento"
      label-for="documentType"
    >
      <v-select
        id="documentType"
        v-model="documentType"
        :class="errors.length > 0 ? 'error-select' : ''"
        :filter="fuseSearch"
        label="name"
        :options="dataOptions"
        :placeholder="'Tipo do Documento'"
        :disabled="readonly"
        :clearable="!readonly"
        @open="onCreate()"
      >
        <template #option="{ name }">
          <span>{{ name }}</span>
        </template>

        <template #selected-option="{ name }">
          <span>{{ name }}</span>
        </template>

        <template #no-options>
          Não há opções de Tipo do Documento.
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>
<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import vSelect from 'vue-select'
import Fuse from 'fuse.js'
import syslic from '@/syslic'
import truncate from '@/components/utils/filters/truncate'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  filters: {
    truncate,
  },
  model: {
    prop: 'documentTypeValue',
    event: 'documentTypeChange',
  },
  props: {
    documentTypeValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    const dataOptions = []
    const newDocumentTypeValue = this.documentTypeValue

    return {
      dataOptions,
      required,
      newDocumentTypeValue,
    }
  },
  computed: {
    documentType: {
      get() {
        return this.newDocumentTypeValue
      },
      set(value) {
        this.newDocumentTypeValue = value
        this.$emit('documentTypeChange', this.newDocumentTypeValue)
      },
    },
  },
  watch: {
    documentTypeValue(newVal) {
      this.newDocumentTypeValue = newVal
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .contract
        .documentType
        .fetchDocumentTypes()
        .then(response => {
          this.dataOptions = response.data.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['name'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" scoped>
.v-select {
  background-color: #fff;
}
</style>
